(function () {
	'use strict';

	angular
		.module('app')
		.controller('videoController', videoController);

	videoController.$inject = ['$scope'];
	function videoController($scope, videoController) {
		/* jshint validthis:true */
		var vm = this;
		vm.id = '';
		vm.videoClosingElement = null;
		vm.embedCode = '';
		vm.player = null;
		vm.enableYTJsAPI = 'enablejsapi=1';
		vm.init = init;
		vm.initPlayer = initPlayer;
		vm.pauseVideo = pauseVideo;
		vm.closeForm = closeForm;

		function init(src, modal, id) {
			vm.embedCode = src;
			vm.id = id;
			vm.initPlayer();

			if (modal === 'true') {
				document.body.addEventListener('click',
					function(event) {
						if (!$(event.target).closest('.video-modal.fade.ng-scoop.in').length &&
							!$(event.target).is('.video-modal.fade.ng-scoop.in')) {
							if ($(event.target).closest('.video-modal.fade.ng-scoop.in').prevObject[0].id === vm.id) {
								vm.pauseVideo();
							}
						}
					});
			} else {
				var li = document.getElementsByClassName('c-service-nav__link');

				var i;
				for (i = 0; i < li.length; i++) {
					li[i].addEventListener('click',
						function (event) {
							if (!$(event.target).is('.active') && $(event.target).hret !== '#' + vm.id) {
								vm.pauseVideo();
							}
						});
				}
			}
		}
		function initPlayer() {
			var iframe = document.getElementById(vm.id).querySelector('iframe');

			if (vm.embedCode.includes('vimeo')) {
				vm.player = new Vimeo.Player(iframe);
			}
			else if (vm.embedCode.includes('youtube')) {
				iframe.id = vm.id + 1;
				var src = iframe.src;

				if (!src.includes(vm.enableYTJsAPI)) {
					if (!src.includes('?')) {
						iframe.src = src + '?' + vm.enableYTJsAPI;
					} else {
						iframe.src = src + '&' + vm.enableYTJsAPI;
					}
				}

				window.YT.ready(function () {
					vm.player = new YT.Player(vm.id + 1,
						{
							events: {
							}
						});
				});
			}

		}
		function pauseVideo() {
			if (vm.embedCode.includes('vimeo')) {
				vm.player.pause();
			}
			else if (vm.embedCode.includes('youtube')) {
				vm.player.pauseVideo();
			}
		}
		function closeForm() {
			vm.pauseVideo();
		}
	}
})();